export { SliderFoto } from './SliderFoto'